import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_INFLUX_BASE}/query?pretty=true`;
const AUTH_TOKEN = process.env.REACT_APP_INFLUX_TOKEN;

const DB = "porto_lot_aggregates";
export const MEASUREMENTS = ["Grid", "Total_Consumption", "Total_Production"];

export const fetchAggregateSeries = createAsyncThunk(
  "portoAggregates/fetchSeries",
  async ({ measurement, startISO, endISO }, thunkAPI) => {
    try {
      const q = `
        SELECT *
        FROM "${measurement}"
        WHERE time >= '${startISO}' AND time <= '${endISO}'
      `;

      const { data } = await axios.get(API_URL, {
        params: { db: DB, q },
        headers: { Authorization: `Token ${AUTH_TOKEN}` },
      });

      const s = data?.results?.[0]?.series?.[0];
      if (!s) return { measurement, points: [], meta: { unit: null } };

      const tIdx = s.columns.indexOf("time");
      const vIdx = s.columns.indexOf("value");
      const uIdx = s.columns.indexOf("unit");

      const points = (s.values || []).map((row) => ({
        t: row[tIdx], // keep ISO string
        y: Number(row[vIdx]) || 0,
      }));

      // unit is same for all rows, take first
      const unit = s.values?.[0]?.[uIdx] ?? null;

      return { measurement, points, meta: { unit } };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const portoAggregatesSlice = createSlice({
  name: "portoAggregates",
  initialState: {
    seriesByMeasurement: {}, // { Grid: [{t,y}...], Total_Consumption: ... }
    metaByMeasurement: {},   // { Grid: {unit}, ... }
    loading: false,
    pendingCount: 0, // number of in-flight requests (one per measurement)
    error: null,
  },
  reducers: {
    clearSeries(state) {
      state.seriesByMeasurement = {};
      state.metaByMeasurement = {};
      state.error = null;
    },
  },
  extraReducers: (b) => {
    // loading stays true until ALL parallel measurement requests have settled
    b.addCase(fetchAggregateSeries.pending, (s) => {
      s.pendingCount += 1;
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchAggregateSeries.fulfilled, (s, a) => {
      s.pendingCount = Math.max(0, s.pendingCount - 1);
      s.loading = s.pendingCount > 0;
      const { measurement, points, meta } = a.payload;
      s.seriesByMeasurement[measurement] = points;
      s.metaByMeasurement[measurement] = meta;
    });
    b.addCase(fetchAggregateSeries.rejected, (s, a) => {
      s.pendingCount = Math.max(0, s.pendingCount - 1);
      s.loading = s.pendingCount > 0;
      s.error = a.payload;
    });
  },
});

export const { clearSeries } = portoAggregatesSlice.actions;
export default portoAggregatesSlice.reducer;